"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMemo = exports.validateAddress = exports.getAddress = void 0;
const logs_1 = require("@ledgerhq/logs");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const consts_1 = require("../../consts");
const api_1 = require("./api");
const getAddress = (a) => a.freshAddresses.length > 0
    ? a.freshAddresses[0]
    : { address: a.freshAddress, derivationPath: a.freshAddressPath };
exports.getAddress = getAddress;
function validateAddress(address) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const res = yield (0, api_1.fetchBalances)(address);
            if (!res.balances)
                throw Error((_a = res.details) === null || _a === void 0 ? void 0 : _a.error_message);
            return { isValid: true };
        }
        catch (e) {
            (0, logs_1.log)("error", (_b = e.message) !== null && _b !== void 0 ? _b : "Failed to validate address");
            return { isValid: false };
        }
    });
}
exports.validateAddress = validateAddress;
function validateMemo(memo) {
    const res = (0, bignumber_js_1.default)(memo !== null && memo !== void 0 ? memo : 0);
    if (res.isNaN() || res.lt(0) || res.gt((0, bignumber_js_1.default)(consts_1.MAX_MEMO_VALUE))) {
        return { isValid: false };
    }
    return { isValid: true };
}
exports.validateMemo = validateMemo;
//# sourceMappingURL=addresses.js.map